import { inject, Injectable } from "@angular/core";
import { ThemeService } from "app/core/theme";
import { KeycloakConfigMap } from "./keycloak-config-map";
import { ThemeTypes } from "app/core/theme/theme-types";

@Injectable({ providedIn: "root" })
export class KeycloakConfigService {
  private themeService = inject(ThemeService);
  private _config: {
    url: string;
    realm: string;
    clientId: string;
  };

  get config() {
    return this._config;
  }

  async loadConfig(): Promise<void> {
    const theme = this.themeService.getThemeData();
    this._config =
      KeycloakConfigMap[theme.value] ??
      KeycloakConfigMap[ThemeTypes.NconnectVoiceTheme];
  }
}
